import { render, staticRenderFns } from "./TransitionExpand.vue?vue&type=template&id=0a4f73fd&scoped=true"
import script from "./TransitionExpand.vue?vue&type=script&lang=ts"
export * from "./TransitionExpand.vue?vue&type=script&lang=ts"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=0a4f73fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f73fd",
  null
  
)

export default component.exports